import { FetchError } from './FetchError.js';

interface BaseRequest {
    url: string;
    headers?: Record<string, string>;
}

interface SimpleRequest extends BaseRequest {
    method?: 'GET' | 'HEAD' | 'DELETE';
    data?: never;
}

interface DataRequest extends BaseRequest {
    method: 'POST' | 'PUT' | 'PATCH';
    data?: unknown;
}

export type FetchRequest = SimpleRequest | DataRequest;

export async function fetchJson<T>(request: FetchRequest) {
    const headers: Record<string, string> = { ...request.headers };

    const requestInit: RequestInit = {
        method: request.method || 'GET',
        headers: headers,
        referrerPolicy: 'origin',
    };

    if (request.data) {
        headers['Content-Type'] = 'application/json';
        requestInit.body = JSON.stringify(request.data);
    }

    const response = await fetch(request.url, requestInit);
    if (!response.ok) {
        throw new FetchError(response);
    }

    return (await response.json()) as T;
}
